
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// // import jwtDecode from "jwt-decode";

// function useSession() {
//   const navigate = useNavigate();
//   const [lastActivity, setLastActivity] = useState(Date.now());
//   let inactivityTimer = null; // Declare the timer variable

//   useEffect(() => {
//     // const jwtToken = localStorage.getItem("jwtToken");
//     if (!jwtToken) {
//       navigate("/");
//     } else {
//     }
//   }, [navigate]);

//   useEffect(() => {
//     // Set up a timer to check for inactivity
//     const inactivityTimer = setInterval(() => {
//       const currentTime = Date.now();
//       const inactiveTime = currentTime - lastActivity;

//       // If the user has been inactive for 10 minutes (600,000 milliseconds), log them out and clear data
//       if (inactiveTime >= 1200000) {
//         // localStorage.removeItem("jwtToken");
//         // localStorage.removeItem("userData");
//         navigate("/adminlogin");
//       }
//     }, 100000); // Check every 10 seconds for inactivity

//     return () => {
//       clearInterval(inactivityTimer);
//     };
//   }, [lastActivity, navigate]);

//   // This effect will run when the component unmounts
//   useEffect(() => {
//     return () => {
//       // Clear the timer when the component unmounts
//       clearInterval(inactivityTimer);
//     };
//   }, []);

//   return { setLastActivity };
// }

// export default useSession;




// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// function useSession() {
//   const navigate = useNavigate();
//   const [lastActivity, setLastActivity] = useState(Date.now());
//   let inactivityTimer = null;

//   useEffect(() => {
//     const jwtToken = localStorage.getItem("jwtToken");
//     if (!jwtToken) {
//       navigate("/");
//     } else {
//       const handleActivity = () => {
//         setLastActivity(Date.now());
//       };

//       // Add event listeners for mousemove and keydown to detect user activity
//       document.addEventListener("mousemove", handleActivity);
//       document.addEventListener("keydown", handleActivity);

//       return () => {
//         // Remove event listeners when the component unmounts
//         document.removeEventListener("mousemove", handleActivity);
//         document.removeEventListener("keydown", handleActivity);
//       };
//     }
//   }, [navigate]);

//   useEffect(() => {
//     const checkInactivity = () => {
//       const currentTime = Date.now();
//       const inactiveTime = currentTime - lastActivity;

//       if (inactiveTime >= 5000) {
//         // 10 minutes in milliseconds
//         // Log out the user and clear data
//         // localStorage.removeItem("jwtToken");
//         // localStorage.removeItem("userData");
//         navigate("/login",{state:'SessionExpired'});
//       }
//     };

//     // Set up a timer to periodically check for inactivity
//     inactivityTimer = setInterval(checkInactivity, 1000); // Check every 10 seconds

//     return () => {
//       // Clear the timer and remove event listeners when the component unmounts
//       clearInterval(inactivityTimer);
//       document.removeEventListener("mousemove", checkInactivity);
//       document.removeEventListener("keydown", checkInactivity);
//     };
//   }, [lastActivity, navigate]);

//   return { setLastActivity };
// }

// export default useSession;


import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function useSession() {
  const navigate = useNavigate();
  const [lastActivity, setLastActivity] = useState(Date.now());
  let inactivityTimer = null;

  useEffect(() => {
    const jwtToken = localStorage.getItem("token");

    if (!jwtToken) {
      navigate("/login");
    } else {
      const handleActivity = () => {
        setLastActivity(Date.now());
      };

      // Add event listeners for mousemove and keydown to detect user activity
      document.addEventListener("mousemove", handleActivity);
      // document.addEventListener("keydown", handleActivity);

      // Set up a timer to periodically check for inactivity
      inactivityTimer = setInterval(() => {
        const currentTime = Date.now();
        const inactiveTime = currentTime - lastActivity;

        if (inactiveTime >= 600000) {
          // 10 minutes in milliseconds
          // Log out the user and clear data
          localStorage.removeItem("jwtToken");
          localStorage.removeItem("userData");
          navigate("/login");
        }
      }, 10000); // Check every 10 seconds for inactivity

      return () => {
        // Clear the timer and remove event listeners when the component unmounts
        clearInterval(inactivityTimer);
        document.removeEventListener("mousemove", handleActivity);
        // document.removeEventListener("keydown", handleActivity);
      };
    }
  }, [lastActivity, navigate]);

  return { setLastActivity };
}

export default useSession;
